<template>
  <div>
    <canvas :id="idCanva"></canvas>
    <LoadingCover spinner="dotsbar" v-show="loading" />
  </div>
</template>
<script>
  import moment from "moment";
  import { uuid } from "vue-uuid";
  import { Chart, registerables } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { dataCostoVentasDocumentos } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(...registerables)

  export default {
    name: "SalesRankingChart",
    data() {
      return {
        moment,
        uuid,
        formatter,
        loading: false,
        idCanva: "",
        colorsLabels: [
          CONSTANTS.colors.color01,
          CONSTANTS.colors.color02,
          CONSTANTS.colors.color03,
          CONSTANTS.colors.color05,
          CONSTANTS.colors.color07,
          CONSTANTS.colors.color08,
          CONSTANTS.colors.color10
        ],
        dataSalesCosts: []
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      reportType: String,
      utilityType: String,
      idCity: String,
      idBranch: String,
      idEmployeeGroup: String,
      idEmployee: String,
      orderBy: String,
      valuesDivisor: Number,
      valuesSing: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesRanking() {
        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Tipo_Reporte": this.reportType,
            "Tipo_Utilidad": this.utilityType,
            "Id_Ciudad": this.idCity,
            "Id_Sucursal": this.idBranch,
            "Id_GrupoPersonal": this.idEmployeeGroup,
            "Id_Personal": this.idEmployee,
            "Orden": this.orderBy
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.dataSalesCosts = this.processTop(response, 10);
        } catch (error) {
          console.log(error)          
        }
      },
      processTop(data, top) {
        const dataTopIni = data.slice(0, top);
        const dataOthers = data.slice(top + 1, data.length);

        if (dataOthers.length === 0) {
          return dataTopIni;
        }

        const othersValues = dataOthers.reduce((totalizator, item) => {
          return {
            Descripcion: "Otros",
            Valor_Mercancia: totalizator.Valor_Mercancia + (item.Valor_Mercancia || 0),
            Valor_Utilidad: totalizator.Valor_Utilidad + (item.Valor_Utilidad || 0)
          }
        }, 
        { 
          Descripcion: "Otros", 
          Valor_Mercancia: 0, 
          Valor_Utilidad: 0
        });

        return [...dataTopIni, othersValues];
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          maintainAspectRadio: false,
          interaction: {
            mode: "index",
            intersect: false
          },
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                boxWidth: 5,
                boxHeight: 5,
                font: {
                  size: 10
                }
              }
            },
            tooltip: {
              enabled: true,
              position: "nearest",
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: "midnightblue",
              callbacks: {
                label : function (context) {
                  return [context.dataset.label, "$" + context.formattedValue] + "M";
                }
              }
            },
            datalabels: {
              font: {
                size: 10
              },
              formatter: (value) => {
                let sum = 0
                this.dataSalesCosts.map(data => sum += (data.Valor_Mercancia / this.valuesDivisor))
                let percentage = ((value * 100) / sum).toFixed(2)

                return `${percentage}%`
              }
            }
          }
        }

        const chart = new Chart(document.getElementById(this.idCanva), {
          type: "bar",
          data: {
            labels: this.dataSalesCosts.map(data => data.Descripcion),
            datasets: [
              {
                type: "bar",
                label: "Ventas",
                data: this.dataSalesCosts.map(data => (data.Valor_Mercancia / this.valuesDivisor)),
                fill: false,
                borderColor: this.colorsLabels[2],
                backgroundColor: this.colorsLabels[2]
              },
              {
                type: "bar",
                label: "Utilidad",
                data: this.dataSalesCosts.map(data => (data.Valor_Utilidad / this.valuesDivisor)),
                fill: false,
                borderColor: this.colorsLabels[1],
                backgroundColor: this.colorsLabels[1]
              }
            ]
          },
          options: optionsChart,
          plugins: [ChartDataLabels]
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true;

      try {
        this.idCanva = uuid.v1();

        await this.getDataSalesRanking();
        this.setupChart();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
</script>
